import { render, staticRenderFns } from "./tableHistory.vue?vue&type=template&id=066c76de&scoped=true"
import script from "./tableHistory.vue?vue&type=script&lang=js"
export * from "./tableHistory.vue?vue&type=script&lang=js"
import style0 from "./tableHistory.vue?vue&type=style&index=0&id=066c76de&prod&scoped=true&lang=css"
import style1 from "./tableHistory.vue?vue&type=style&index=1&id=066c76de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066c76de",
  null
  
)

export default component.exports